import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './../../../assets/css/mentor/mentordashboard/RoadmapSuggestions.css';
import MyMasterLayout from './../../../layouts/Mentor/MyMasterlayout';

const Portal = ({ children }) => {
  const el = useRef(document.createElement('div'));
  useEffect(() => {
    const node = el.current;
    node.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;z-index:2147483647;pointer-events:all;';
    document.body.appendChild(node);
    document.body.style.overflow = 'hidden';
    return () => { document.body.removeChild(node); document.body.style.overflow = ''; };
  }, []);
  return ReactDOM.createPortal(children, el.current);
};

const RoadmapSuggestions = () => {
  const [activeTab, setActiveTab]             = useState('popular');
  const [viewMode, setViewMode]               = useState('list');
  const [selectedRoadmap, setSelectedRoadmap] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [createStep, setCreateStep]           = useState(1);
  const [createSubmitted, setCreateSubmitted] = useState(false);

  const emptyWeek = () => ({ title: '', topics: ['', '', ''] });

  const [newRoadmap, setNewRoadmap] = useState({
    title: '', duration: '', level: 'Beginner',
    description: '', objectives: ['', '', ''],
    weeks: [emptyWeek()]
  });

  const [allRoadmaps, setAllRoadmaps] = useState([
    {
      id: 1, isMine: false, suggested: false,
      title: 'Full Stack Web Development', duration: '12 weeks', level: 'Beginner',
      students: 24, completionRate: 85,
      image: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=400&h=250&fit=crop',
      description: 'Master modern web development from frontend to backend with hands-on projects.',
      objectives: ['Build responsive websites using HTML, CSS, and JavaScript','Create dynamic web applications with React','Develop RESTful APIs using Node.js and Express','Work with databases (MongoDB & PostgreSQL)','Deploy applications to production'],
      weeks: [
        { week:1,  title:'HTML & CSS Fundamentals', topics:['HTML5 Semantic Elements','CSS Grid & Flexbox','Responsive Design','CSS Animations'],              completed:true  },
        { week:2,  title:'JavaScript Basics',        topics:['Variables & Data Types','Functions & Scope','DOM Manipulation','Events Handling'],                completed:true  },
        { week:3,  title:'Advanced JavaScript',      topics:['ES6+ Features','Async/Await','Promises','API Integration'],                                      completed:true  },
        { week:4,  title:'React Fundamentals',       topics:['Components & Props','State Management','Hooks','React Router'],                                   completed:false },
        { week:5,  title:'Advanced React',           topics:['Context API','Custom Hooks','Performance Optimization','Form Handling'],                          completed:false },
        { week:6,  title:'Node.js & Express',        topics:['Node.js Basics','Express Setup','Middleware','REST API Design'],                                  completed:false },
        { week:7,  title:'Database Integration',     topics:['MongoDB Setup','Mongoose ODM','CRUD Operations','Data Relationships'],                            completed:false },
        { week:8,  title:'Authentication',           topics:['JWT Tokens','Password Hashing','User Sessions','Protected Routes'],                               completed:false },
        { week:9,  title:'Advanced Backend',         topics:['File Uploads','Email Integration','Error Handling','API Security'],                               completed:false },
        { week:10, title:'Testing & Debugging',      topics:['Unit Testing','Integration Testing','Debugging Tools','Performance Testing'],                     completed:false },
        { week:11, title:'Deployment & DevOps',      topics:['Git & GitHub','Heroku Deployment','Environment Variables','CI/CD Basics'],                       completed:false },
        { week:12, title:'Final Project',            topics:['Project Planning','Full Stack Implementation','Code Review','Project Presentation'],              completed:false },
      ]
    },
    {
      id: 2, isMine: false, suggested: false,
      title: 'Mobile App Development', duration: '10 weeks', level: 'Beginner',
      students: 15, completionRate: 78,
      image: 'https://images.unsplash.com/photo-1551650975-87deedd944c3?w=400&h=250&fit=crop',
      description: 'Learn to build native mobile applications for iOS and Android using React Native.',
      objectives: ['Understand mobile app development fundamentals','Build cross-platform apps with React Native','Implement navigation and state management','Integrate with APIs and databases','Publish apps to App Store and Play Store'],
      weeks: [
        { week:1,  title:'React Native Setup',     topics:['Environment Setup','React Native CLI','First App','Basic Components'],           completed:true  },
        { week:2,  title:'Styling & Layout',       topics:['StyleSheet API','Flexbox Layout','Responsive Design','Custom Components'],       completed:true  },
        { week:3,  title:'Navigation',             topics:['React Navigation','Stack Navigator','Tab Navigator','Drawer Navigator'],         completed:false },
        { week:4,  title:'State Management',       topics:['useState Hook','Context API','Redux Basics','AsyncStorage'],                     completed:false },
        { week:5,  title:'API Integration',        topics:['Fetch API','Axios','REST APIs','Error Handling'],                                completed:false },
        { week:6,  title:'Native Features',        topics:['Camera Access','Location Services','Push Notifications','Device Storage'],       completed:false },
        { week:7,  title:'Authentication',         topics:['User Login','JWT Tokens','Social Login','Biometric Auth'],                       completed:false },
        { week:8,  title:'Database & Offline',     topics:['SQLite','Realm Database','Offline Sync','Data Caching'],                        completed:false },
        { week:9,  title:'Testing',                topics:['Jest Testing','Performance Tips','Memory Management','App Size Optimization'],   completed:false },
        { week:10, title:'Deployment',             topics:['App Store Submission','Play Store Release','Beta Testing','App Updates'],        completed:false },
      ]
    },
    {
      id: 3, isMine: false, suggested: false,
      title: 'Data Science with Python', duration: '14 weeks', level: 'Intermediate',
      students: 18, completionRate: 72,
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop',
      description: 'Dive deep into data analysis, visualization, and machine learning using Python.',
      objectives: ['Master Python programming for data science','Perform data analysis with Pandas and NumPy','Create visualizations with Matplotlib and Seaborn','Build machine learning models','Deploy ML models to production'],
      weeks: [
        { week:1,  title:'Python Fundamentals',   topics:['Python Syntax','Data Structures','Functions','OOP Basics'],                         completed:true  },
        { week:2,  title:'NumPy Basics',           topics:['Arrays','Array Operations','Broadcasting','Linear Algebra'],                        completed:false },
        { week:3,  title:'Pandas',                 topics:['DataFrames','Data Cleaning','Data Manipulation','Grouping & Aggregation'],          completed:false },
        { week:4,  title:'Data Visualization',     topics:['Matplotlib','Seaborn','Plotly','Interactive Charts'],                              completed:false },
        { week:5,  title:'Statistical Analysis',   topics:['Descriptive Statistics','Hypothesis Testing','Correlation','Probability'],         completed:false },
        { week:6,  title:'ML Intro',               topics:['ML Concepts','Scikit-learn','Train-Test Split','Model Evaluation'],                completed:false },
        { week:7,  title:'Supervised Learning',    topics:['Linear Regression','Logistic Regression','Decision Trees','Random Forests'],       completed:false },
        { week:8,  title:'Unsupervised Learning',  topics:['K-Means Clustering','PCA','Hierarchical Clustering','Anomaly Detection'],         completed:false },
        { week:9,  title:'Deep Learning',          topics:['Neural Networks','TensorFlow','Keras','CNN Basics'],                               completed:false },
        { week:10, title:'NLP',                    topics:['Text Processing','Sentiment Analysis','Word Embeddings','Text Classification'],    completed:false },
        { week:11, title:'Time Series',            topics:['Time Series Data','ARIMA Models','Forecasting','Trend Analysis'],                  completed:false },
        { week:12, title:'Model Deployment',       topics:['Flask API','Model Serialization','Cloud Deployment','Model Monitoring'],           completed:false },
        { week:13, title:'Big Data Tools',         topics:['Apache Spark','PySpark','Distributed Computing','Data Pipelines'],                 completed:false },
        { week:14, title:'Capstone Project',       topics:['Project Planning','Implementation','Presentation','Documentation'],                completed:false },
      ]
    }
  ]);

  const resetForm = () => {
    setNewRoadmap({ title:'', duration:'', level:'Beginner', description:'', objectives:['','',''], weeks:[emptyWeek()] });
    setCreateStep(1); setCreateSubmitted(false);
  };
  const openCreate  = () => { resetForm(); setShowCreateModal(true); };
  const closeCreate = () => { setShowCreateModal(false); resetForm(); };

  const step1Valid = newRoadmap.title.trim() && newRoadmap.duration.trim() &&
    newRoadmap.description.trim() && newRoadmap.objectives.some(o => o.trim());
  const step2Valid = newRoadmap.weeks.every(w => w.title.trim() && w.topics.some(t => t.trim()));

  const handleSubmitCreate = () => {
    const imgs = {
      Beginner:     'https://images.unsplash.com/photo-1484417894907-623942c8ee29?w=400&h=250&fit=crop',
      Intermediate: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=400&h=250&fit=crop',
      Advanced:     'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=400&h=250&fit=crop',
    };
    const created = {
      id: Date.now(), isMine: true, suggested: false,
      title: newRoadmap.title, duration: newRoadmap.duration, level: newRoadmap.level,
      students: 0, completionRate: 0,
      image: imgs[newRoadmap.level] || imgs.Beginner,
      description: newRoadmap.description,
      objectives: newRoadmap.objectives.filter(o => o.trim()),
      weeks: newRoadmap.weeks.map((w, i) => ({
        week: i+1, title: w.title,
        topics: w.topics.filter(t => t.trim()), completed: false
      }))
    };
    setAllRoadmaps(prev => [created, ...prev]);
    setCreateSubmitted(true);
  };

  const handleSuggest = (roadmap) => {
    setAllRoadmaps(prev => prev.map(r => r.id === roadmap.id ? { ...r, suggested: true } : r));
    if (selectedRoadmap?.id === roadmap.id) setSelectedRoadmap({ ...roadmap, suggested: true });
    alert(`Roadmap "${roadmap.title}" has been suggested to admin for review!`);
  };

  const handleViewRoadmap = (roadmap) => { setSelectedRoadmap(roadmap); setViewMode('detail'); };
  const handleBackToList  = () => { setViewMode('list'); setSelectedRoadmap(null); };

  // ── Reusable input style ──
  const IS = (extra = {}) => ({
    width: '100%', padding: '11px 14px', border: '2px solid #e8ecf0',
    borderRadius: 10, fontSize: 14, fontFamily: 'inherit', outline: 'none',
    boxSizing: 'border-box', transition: 'border-color 0.2s, box-shadow 0.2s',
    background: '#fff', color: '#1a1a2e', ...extra
  });
  const onFocus = e => { e.target.style.borderColor = '#781c2e'; e.target.style.boxShadow = '0 0 0 3px rgba(120,28,46,0.08)'; };
  const onBlur  = e => { e.target.style.borderColor = '#e8ecf0'; e.target.style.boxShadow = 'none'; };

  // ── Label component ──
  const Label = ({ text, required, hint }) => (
    <div style={{ marginBottom: 8 }}>
      <span style={{ fontSize: 13, fontWeight: 700, color: '#374151' }}>{text}</span>
      {required && <span style={{ color: '#e74c3c', marginLeft: 3 }}>*</span>}
      {hint && <span style={{ fontSize: 12, color: '#9ca3af', marginLeft: 8 }}>{hint}</span>}
    </div>
  );

  // ── Step indicator ──
  const StepIndicator = () => (
    <div style={{ display: 'flex', alignItems: 'center', padding: '20px 28px 0' }}>
      {[{ n:1, l:'Basic Info' }, { n:2, l:'Weekly Plan' }, { n:3, l:'Preview' }].map((s, i) => (
        <React.Fragment key={s.n}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5 }}>
            <div style={{
              width: 36, height: 36, borderRadius: '50%',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontWeight: 800, fontSize: 14,
              background: createStep > s.n ? '#059669' : createStep === s.n ? 'linear-gradient(135deg,#781c2e,#a52a3d)' : '#f1f5f9',
              color: createStep >= s.n ? '#fff' : '#94a3b8',
              boxShadow: createStep === s.n ? '0 4px 14px rgba(120,28,46,0.35)' : 'none',
              transition: 'all 0.25s'
            }}>
              {createStep > s.n ? <i className="bi bi-check-lg" style={{ fontSize: 16 }}></i> : s.n}
            </div>
            <span style={{ fontSize: 11, fontWeight: 700, color: createStep >= s.n ? '#781c2e' : '#94a3b8', whiteSpace: 'nowrap' }}>
              {s.l}
            </span>
          </div>
          {i < 2 && (
            <div style={{ flex: 1, height: 2, margin: '0 8px', marginBottom: 18,
              background: createStep > s.n ? '#059669' : '#e2e8f0', transition: 'background 0.3s' }} />
          )}
        </React.Fragment>
      ))}
    </div>
  );

  // ── Roadmap Card ──
  const RoadmapCard = ({ roadmap }) => (
    <div className="roadmap-card" style={{ position: 'relative' }}>
      {roadmap.isMine && (
        <span style={{ position: 'absolute', top: 12, left: 12, zIndex: 2,
          background: 'linear-gradient(135deg,#781c2e,#a52a3d)', color: '#fff',
          fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 20 }}>
          ✏️ My Roadmap
        </span>
      )}
      {roadmap.suggested && (
        <span style={{ position: 'absolute', top: 12, right: 12, zIndex: 2,
          background: '#059669', color: '#fff',
          fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 20 }}>
          ✓ Suggested
        </span>
      )}
      <div className="roadmap-image">
        <img src={roadmap.image} alt={roadmap.title} />
        <div className="roadmap-overlay">
          <button className="btn-action btn-primary" onClick={() => handleViewRoadmap(roadmap)}>
            <i className="bi bi-eye"></i> View Details
          </button>
        </div>
      </div>
      <div className="roadmap-content">
        <h3 className="roadmap-title">{roadmap.title}</h3>
        <div className="roadmap-meta">
          <span className="meta-item"><i className="bi bi-clock"></i> {roadmap.duration}</span>
          <span className={`badge badge-${roadmap.level.toLowerCase()}`}>{roadmap.level}</span>
        </div>
        <div className="roadmap-stats">
          <span className="stat-item"><i className="bi bi-people"></i> {roadmap.students} Students</span>
          {roadmap.isMine
            ? <span className="stat-item" style={{ color: '#f59e0b' }}><i className="bi bi-star-fill"></i> My Creation</span>
            : <span className="stat-item success"><i className="bi bi-check-circle"></i> {roadmap.completionRate}% Complete</span>
          }
        </div>
        <button className="btn-suggest" onClick={() => handleSuggest(roadmap)}
          disabled={roadmap.suggested}
          style={{ opacity: roadmap.suggested ? 0.6 : 1, cursor: roadmap.suggested ? 'not-allowed' : 'pointer' }}>
          {roadmap.suggested
            ? <><i className="bi bi-check-lg"></i> Suggested to Admin</>
            : <><i className="bi bi-send"></i> Suggest to Admin</>}
        </button>
      </div>
    </div>
  );

  // ── Detail View (original) ──
  const renderDetail = () => {
    if (!selectedRoadmap) return null;
    const done = selectedRoadmap.weeks.filter(w => w.completed).length;
    const pct  = Math.round((done / selectedRoadmap.weeks.length) * 100);
    return (
      <div className="roadmap-detail-wrapper">
        <button className="btn-back" onClick={handleBackToList}>
          <i className="bi bi-arrow-left"></i> Back to Roadmaps
        </button>
        <div className="roadmap-detail-header">
          <div className="roadmap-detail-image">
            <img src={selectedRoadmap.image} alt={selectedRoadmap.title} />
          </div>
          <div className="roadmap-detail-info">
            <h1 className="roadmap-detail-title">{selectedRoadmap.title}</h1>
            <p className="roadmap-detail-description">{selectedRoadmap.description}</p>
            <div className="roadmap-detail-meta">
              <div className="meta-badge"><i className="bi bi-clock-history"></i><span>{selectedRoadmap.duration}</span></div>
              <div className="meta-badge"><i className="bi bi-bar-chart"></i><span>{selectedRoadmap.level}</span></div>
              <div className="meta-badge"><i className="bi bi-people-fill"></i><span>{selectedRoadmap.students} Students</span></div>
            </div>
            <div className="progress-section">
              <div className="progress-header">
                <span className="progress-label">Overall Progress</span>
                <span className="progress-value">{pct}%</span>
              </div>
              <div className="progress-bar-container">
                <div className="progress-bar-fill" style={{ width: `${pct}%` }}></div>
              </div>
              <div className="progress-stats"><span>{done} of {selectedRoadmap.weeks.length} weeks completed</span></div>
            </div>
            <button className="btn-suggest-large" onClick={() => handleSuggest(selectedRoadmap)}
              disabled={selectedRoadmap.suggested}
              style={{ opacity: selectedRoadmap.suggested ? 0.6 : 1, cursor: selectedRoadmap.suggested ? 'not-allowed' : 'pointer' }}>
              {selectedRoadmap.suggested
                ? <><i className="bi bi-check-lg"></i> Already Suggested</>
                : <><i className="bi bi-send-fill"></i> Suggest This Roadmap to Admin</>}
            </button>
          </div>
        </div>
        <div className="roadmap-objectives">
          <h2 className="section-heading"><i className="bi bi-trophy"></i> Learning Objectives</h2>
          <ul className="objectives-list">
            {selectedRoadmap.objectives.map((obj, i) => (
              <li key={i} className="objective-item"><i className="bi bi-check-circle-fill"></i>{obj}</li>
            ))}
          </ul>
        </div>
        <div className="roadmap-timeline">
          <h2 className="section-heading"><i className="bi bi-calendar3"></i> Weekly Breakdown</h2>
          <div className="timeline-container">
            {selectedRoadmap.weeks.map((week, i) => (
              <div key={i} className={`timeline-item ${week.completed ? 'completed' : 'pending'}`}>
                <div className="timeline-marker">
                  {week.completed ? <i className="bi bi-check-circle-fill"></i> : <i className="bi bi-circle"></i>}
                </div>
                <div className="timeline-content">
                  <div className="timeline-header">
                    <h3 className="timeline-week">Week {week.week}</h3>
                    <span className={`timeline-status ${week.completed ? 'status-completed' : 'status-pending'}`}>
                      {week.completed ? 'Completed' : 'Upcoming'}
                    </span>
                  </div>
                  <h4 className="timeline-title">{week.title}</h4>
                  <ul className="timeline-topics">
                    {week.topics.map((t, ti) => <li key={ti} className="timeline-topic"><i className="bi bi-dot"></i>{t}</li>)}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <MyMasterLayout>
      <div className="roadmap-suggestions-wrapper">

        {/* ════ CREATE ROADMAP MODAL ════ */}
        {showCreateModal && (
          <Portal>
            <div onClick={closeCreate} style={{
              position: 'absolute', inset: 0, background: 'rgba(15,23,42,0.6)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20
            }}>
              <div onClick={e => e.stopPropagation()} style={{
                background: '#fff', borderRadius: 20, width: 640, maxWidth: '98vw',
                maxHeight: '94vh', overflowY: 'auto',
                boxShadow: '0 25px 80px rgba(0,0,0,0.3)',
                display: 'flex', flexDirection: 'column'
              }}>

                {/* ── SUCCESS STATE ── */}
                {createSubmitted ? (
                  <div style={{ padding: '56px 40px', textAlign: 'center' }}>
                    <div style={{
                      width: 80, height: 80, borderRadius: '50%',
                      background: 'linear-gradient(135deg,#059669,#047857)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      margin: '0 auto 24px', fontSize: 36, color: '#fff'
                    }}>
                      <i className="bi bi-check-lg"></i>
                    </div>
                    <h2 style={{ fontSize: 24, fontWeight: 800, color: '#1a1a2e', margin: '0 0 12px' }}>
                      Roadmap Created Successfully!
                    </h2>
                    <p style={{ color: '#64748b', fontSize: 14, margin: '0 0 6px', lineHeight: 1.6 }}>
                      <strong style={{ color: '#1a1a2e' }}>"{newRoadmap.title}"</strong> has been added to your roadmap list.
                    </p>
                    <p style={{ color: '#94a3b8', fontSize: 13, margin: '0 0 36px' }}>
                      You can now suggest it to admin using the "Suggest to Admin" button.
                    </p>
                    <button onClick={closeCreate} style={{
                      background: 'linear-gradient(135deg,#781c2e,#a52a3d)', color: '#fff',
                      border: 'none', borderRadius: 12, padding: '13px 36px',
                      fontSize: 14, fontWeight: 700, cursor: 'pointer',
                      boxShadow: '0 4px 16px rgba(120,28,46,0.35)'
                    }}>
                      View My Roadmaps
                    </button>
                  </div>

                ) : (
                  <>
                    {/* ── MODAL HEADER ── */}
                    <div style={{
                      background: 'linear-gradient(135deg,#781c2e 0%,#a52a3d 100%)',
                      borderRadius: '20px 20px 0 0', padding: '22px 28px',
                      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                      flexShrink: 0
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                        <div style={{
                          width: 46, height: 46, borderRadius: 12,
                          background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.2)',
                          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22
                        }}>🗺️</div>
                        <div>
                          <h2 style={{ margin: 0, fontSize: 19, fontWeight: 800, color: '#fff', letterSpacing: '-0.3px' }}>
                            Create New Roadmap
                          </h2>
                          <p style={{ margin: '4px 0 0', fontSize: 13, color: 'rgba(255,255,255,0.7)' }}>
                            Build a learning roadmap and suggest it to admin
                          </p>
                        </div>
                      </div>
                      <button onClick={closeCreate} style={{
                        width: 38, height: 38, borderRadius: '50%',
                        background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.2)',
                        color: '#fff', fontSize: 18, cursor: 'pointer',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        transition: 'background 0.2s'
                      }}>✕</button>
                    </div>

                    {/* ── STEP INDICATOR ── */}
                    <StepIndicator />

                    {/* ── DIVIDER ── */}
                    <div style={{ height: 1, background: '#f1f5f9', margin: '16px 0 0' }} />

                    {/* ════ STEP 1: Basic Information ════ */}
                    {createStep === 1 && (
                      <div style={{ padding: '24px 28px', display: 'flex', flexDirection: 'column', gap: 20 }}>

                        {/* Title */}
                        <div>
                          <Label text="Roadmap Title" required />
                          <input type="text" value={newRoadmap.title}
                            onChange={e => setNewRoadmap(r => ({ ...r, title: e.target.value }))}
                            placeholder="e.g. Full Stack Web Development"
                            style={IS()} onFocus={onFocus} onBlur={onBlur} />
                        </div>

                        {/* Duration + Level */}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                          <div>
                            <Label text="Duration" required hint="e.g. 8 weeks" />
                            <input type="text" value={newRoadmap.duration}
                              onChange={e => setNewRoadmap(r => ({ ...r, duration: e.target.value }))}
                              placeholder="e.g. 10 weeks"
                              style={IS()} onFocus={onFocus} onBlur={onBlur} />
                          </div>
                          <div>
                            <Label text="Difficulty Level" required />
                            <select value={newRoadmap.level}
                              onChange={e => setNewRoadmap(r => ({ ...r, level: e.target.value }))}
                              style={IS({ cursor: 'pointer' })} onFocus={onFocus} onBlur={onBlur}>
                              <option value="Beginner">🟢  Beginner</option>
                              <option value="Intermediate">🟡  Intermediate</option>
                              <option value="Advanced">🔴  Advanced</option>
                            </select>
                          </div>
                        </div>

                        {/* Description */}
                        <div>
                          <Label text="Description" required hint="Brief overview of this roadmap" />
                          <textarea value={newRoadmap.description}
                            onChange={e => setNewRoadmap(r => ({ ...r, description: e.target.value }))}
                            placeholder="Describe what this roadmap covers and who it's designed for..."
                            rows={4} style={IS({ resize: 'vertical' })} onFocus={onFocus} onBlur={onBlur} />
                        </div>

                        {/* Learning Objectives */}
                        <div>
                          <Label text="Learning Objectives" required hint="What will students learn?" />
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                            {newRoadmap.objectives.map((obj, i) => (
                              <div key={i} style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                <div style={{
                                  width: 28, height: 28, borderRadius: '50%', flexShrink: 0,
                                  background: obj.trim() ? 'linear-gradient(135deg,#781c2e,#a52a3d)' : '#f1f5f9',
                                  border: obj.trim() ? 'none' : '2px solid #e2e8f0',
                                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                                  fontSize: 11, fontWeight: 800,
                                  color: obj.trim() ? '#fff' : '#94a3b8', transition: 'all 0.2s'
                                }}>{i + 1}</div>
                                <input type="text" value={obj}
                                  onChange={e => {
                                    const arr = [...newRoadmap.objectives]; arr[i] = e.target.value;
                                    setNewRoadmap(r => ({ ...r, objectives: arr }));
                                  }}
                                  placeholder={`Objective ${i + 1} — e.g. Build REST APIs with Node.js`}
                                  style={{ ...IS(), flex: 1 }} onFocus={onFocus} onBlur={onBlur} />
                                {newRoadmap.objectives.length > 1 && (
                                  <button onClick={() => setNewRoadmap(r => ({
                                    ...r, objectives: r.objectives.filter((_, idx) => idx !== i)
                                  }))} style={{
                                    width: 32, height: 32, border: 'none', flexShrink: 0,
                                    background: '#fef2f2', color: '#ef4444', borderRadius: 8,
                                    cursor: 'pointer', fontSize: 14,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                                  }}>
                                    <i className="bi bi-trash3"></i>
                                  </button>
                                )}
                              </div>
                            ))}
                          </div>
                          <button onClick={() => setNewRoadmap(r => ({ ...r, objectives: [...r.objectives, ''] }))}
                            style={{
                              marginTop: 10, background: '#fdf5f6', color: '#781c2e',
                              border: '2px dashed #f5c0c8', borderRadius: 10, padding: '9px 18px',
                              fontSize: 13, fontWeight: 700, cursor: 'pointer', width: '100%',
                              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6
                            }}>
                            <i className="bi bi-plus-circle"></i> Add Objective
                          </button>
                        </div>
                      </div>
                    )}

                    {/* ════ STEP 2: Weekly Plan ════ */}
                    {createStep === 2 && (
                      <div style={{ padding: '24px 28px' }}>
                        <p style={{ margin: '0 0 20px', fontSize: 13, color: '#64748b', lineHeight: 1.6 }}>
                          Define the weekly schedule for this roadmap. Add a title and topics for each week.
                        </p>

                        {newRoadmap.weeks.map((week, wi) => (
                          <div key={wi} style={{
                            background: '#f8fafc', border: '2px solid #e2e8f0',
                            borderRadius: 14, padding: '18px 20px', marginBottom: 14,
                            transition: 'border-color 0.2s'
                          }}>
                            {/* Week header */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                <div style={{
                                  width: 32, height: 32, borderRadius: 8,
                                  background: 'linear-gradient(135deg,#781c2e,#a52a3d)',
                                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                                  fontSize: 13, fontWeight: 800, color: '#fff'
                                }}>{wi + 1}</div>
                                <span style={{ fontSize: 14, fontWeight: 700, color: '#1a1a2e' }}>
                                  Week {wi + 1}
                                </span>
                              </div>
                              {newRoadmap.weeks.length > 1 && (
                                <button onClick={() => setNewRoadmap(r => ({
                                  ...r, weeks: r.weeks.filter((_, idx) => idx !== wi)
                                }))} style={{
                                  background: '#fef2f2', color: '#ef4444', border: 'none',
                                  borderRadius: 8, padding: '6px 12px', fontSize: 12,
                                  fontWeight: 700, cursor: 'pointer',
                                  display: 'flex', alignItems: 'center', gap: 5
                                }}>
                                  <i className="bi bi-trash3"></i> Remove
                                </button>
                              )}
                            </div>

                            {/* Week title */}
                            <div style={{ marginBottom: 14 }}>
                              <Label text="Week Title" required />
                              <input type="text" value={week.title}
                                onChange={e => {
                                  const weeks = [...newRoadmap.weeks];
                                  weeks[wi] = { ...weeks[wi], title: e.target.value };
                                  setNewRoadmap(r => ({ ...r, weeks }));
                                }}
                                placeholder="e.g. React Fundamentals, Node.js Basics..."
                                style={IS({ background: '#fff' })} onFocus={onFocus} onBlur={onBlur} />
                            </div>

                            {/* Topics */}
                            <div>
                              <Label text="Topics Covered" hint="Add key topics for this week" />
                              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                {week.topics.map((topic, ti) => (
                                  <div key={ti} style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                    <span style={{ color: '#cbd5e1', fontSize: 18, flexShrink: 0 }}>•</span>
                                    <input type="text" value={topic}
                                      onChange={e => {
                                        const weeks = [...newRoadmap.weeks];
                                        const topics = [...weeks[wi].topics]; topics[ti] = e.target.value;
                                        weeks[wi] = { ...weeks[wi], topics };
                                        setNewRoadmap(r => ({ ...r, weeks }));
                                      }}
                                      placeholder={`Topic ${ti + 1}`}
                                      style={{ ...IS({ background: '#fff' }), flex: 1 }}
                                      onFocus={onFocus} onBlur={onBlur} />
                                    {week.topics.length > 1 && (
                                      <button onClick={() => {
                                        const weeks = [...newRoadmap.weeks];
                                        weeks[wi] = { ...weeks[wi], topics: weeks[wi].topics.filter((_, idx) => idx !== ti) };
                                        setNewRoadmap(r => ({ ...r, weeks }));
                                      }} style={{
                                        width: 32, height: 32, border: 'none', flexShrink: 0,
                                        background: '#fef2f2', color: '#ef4444', borderRadius: 8,
                                        cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                      }}>
                                        <i className="bi bi-x-lg" style={{ fontSize: 12 }}></i>
                                      </button>
                                    )}
                                  </div>
                                ))}
                              </div>
                              <button onClick={() => {
                                const weeks = [...newRoadmap.weeks];
                                weeks[wi] = { ...weeks[wi], topics: [...weeks[wi].topics, ''] };
                                setNewRoadmap(r => ({ ...r, weeks }));
                              }} style={{
                                marginTop: 10, background: '#f0f9ff', color: '#0284c7',
                                border: '1.5px dashed #7dd3fc', borderRadius: 8, padding: '7px 14px',
                                fontSize: 12, fontWeight: 700, cursor: 'pointer',
                                display: 'flex', alignItems: 'center', gap: 5
                              }}>
                                <i className="bi bi-plus"></i> Add Topic
                              </button>
                            </div>
                          </div>
                        ))}

                        <button onClick={() => setNewRoadmap(r => ({ ...r, weeks: [...r.weeks, emptyWeek()] }))}
                          style={{
                            width: '100%', padding: '13px', background: '#fdf5f6',
                            color: '#781c2e', border: '2px dashed #f5c0c8', borderRadius: 12,
                            fontSize: 13, fontWeight: 700, cursor: 'pointer',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8
                          }}>
                          <i className="bi bi-plus-circle-fill"></i> Add New Week
                        </button>
                      </div>
                    )}

                    {/* ════ STEP 3: Preview & Submit ════ */}
                    {createStep === 3 && (
                      <div style={{ padding: '24px 28px' }}>
                        <p style={{ margin: '0 0 18px', fontSize: 13, color: '#64748b' }}>
                          Review your roadmap before submitting it to admin.
                        </p>

                        {/* Preview Card */}
                        <div style={{
                          border: '2px solid #e2e8f0', borderRadius: 16, overflow: 'hidden', marginBottom: 20,
                          boxShadow: '0 2px 12px rgba(0,0,0,0.05)'
                        }}>
                          {/* Card header */}
                          <div style={{ background: 'linear-gradient(135deg,#1a1a2e,#2d2d44)', padding: '20px 22px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                              <h3 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: '#fff' }}>
                                {newRoadmap.title}
                              </h3>
                              <span style={{
                                background: newRoadmap.level === 'Beginner' ? '#059669' :
                                  newRoadmap.level === 'Intermediate' ? '#d97706' : '#dc2626',
                                color: '#fff', padding: '4px 12px', borderRadius: 20,
                                fontSize: 11, fontWeight: 700, marginLeft: 10, whiteSpace: 'nowrap'
                              }}>{newRoadmap.level}</span>
                            </div>
                            <div style={{ display: 'flex', gap: 16, marginTop: 10 }}>
                              <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', display: 'flex', alignItems: 'center', gap: 5 }}>
                                <i className="bi bi-clock"></i> {newRoadmap.duration}
                              </span>
                              <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', display: 'flex', alignItems: 'center', gap: 5 }}>
                                <i className="bi bi-calendar3"></i> {newRoadmap.weeks.length} Weeks
                              </span>
                            </div>
                          </div>

                          <div style={{ padding: '18px 22px' }}>
                            <p style={{ margin: '0 0 16px', fontSize: 13, color: '#64748b', lineHeight: 1.6 }}>
                              {newRoadmap.description}
                            </p>

                            {/* Objectives */}
                            <p style={{ margin: '0 0 10px', fontSize: 13, fontWeight: 700, color: '#374151' }}>
                              Learning Objectives
                            </p>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 7, marginBottom: 18 }}>
                              {newRoadmap.objectives.filter(o => o.trim()).map((obj, i) => (
                                <div key={i} style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                                  <i className="bi bi-check-circle-fill" style={{ color: '#781c2e', fontSize: 14, marginTop: 1, flexShrink: 0 }}></i>
                                  <span style={{ fontSize: 13, color: '#4b5563' }}>{obj}</span>
                                </div>
                              ))}
                            </div>

                            {/* Weekly plan mini view */}
                            <p style={{ margin: '0 0 10px', fontSize: 13, fontWeight: 700, color: '#374151' }}>
                              Weekly Breakdown ({newRoadmap.weeks.length} weeks)
                            </p>
                            <div style={{
                              border: '1px solid #f1f5f9', borderRadius: 10, overflow: 'hidden',
                              maxHeight: 200, overflowY: 'auto'
                            }}>
                              {newRoadmap.weeks.map((w, i) => (
                                <div key={i} style={{
                                  display: 'flex', gap: 12, alignItems: 'flex-start',
                                  padding: '10px 14px',
                                  borderBottom: i < newRoadmap.weeks.length - 1 ? '1px solid #f1f5f9' : 'none',
                                  background: i % 2 === 0 ? '#fff' : '#f8fafc'
                                }}>
                                  <div style={{
                                    width: 24, height: 24, borderRadius: 6, flexShrink: 0,
                                    background: 'linear-gradient(135deg,#781c2e,#a52a3d)',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    fontSize: 11, fontWeight: 800, color: '#fff'
                                  }}>{i + 1}</div>
                                  <div>
                                    <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1a2e' }}>{w.title}</div>
                                    <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>
                                      {w.topics.filter(t => t.trim()).join(' · ')}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>

                        {/* Info box */}
                        <div style={{
                          display: 'flex', gap: 12, background: '#f0f9ff',
                          border: '1.5px solid #bae6fd', borderRadius: 12, padding: '14px 16px'
                        }}>
                          <i className="bi bi-info-circle-fill" style={{ color: '#0284c7', fontSize: 18, flexShrink: 0 }}></i>
                          <p style={{ margin: 0, fontSize: 13, color: '#0369a1', lineHeight: 1.6 }}>
                            After creating, you can suggest this roadmap to admin from the roadmap list.
                            Admin will review and approve it before it becomes available to students.
                          </p>
                        </div>
                      </div>
                    )}

                    {/* ── FOOTER ── */}
                    <div style={{
                      padding: '16px 28px', borderTop: '1px solid #f1f5f9',
                      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                      flexShrink: 0, background: '#fff', borderRadius: '0 0 20px 20px'
                    }}>
                      <button onClick={() => createStep > 1 ? setCreateStep(s => s - 1) : closeCreate()}
                        style={{
                          padding: '10px 22px', borderRadius: 10, border: '2px solid #e2e8f0',
                          background: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 700,
                          color: '#64748b', display: 'flex', alignItems: 'center', gap: 6
                        }}>
                        {createStep === 1 ? <><i className="bi bi-x-lg"></i> Cancel</> : <><i className="bi bi-arrow-left"></i> Back</>}
                      </button>

                      {/* Step dots */}
                      <div style={{ display: 'flex', gap: 6 }}>
                        {[1, 2, 3].map(n => (
                          <div key={n} style={{
                            width: createStep === n ? 24 : 8, height: 8, borderRadius: 4,
                            background: createStep >= n ? '#781c2e' : '#e2e8f0', transition: 'all 0.25s'
                          }} />
                        ))}
                      </div>

                      {createStep < 3 ? (
                        <button onClick={() => setCreateStep(s => s + 1)}
                          disabled={createStep === 1 ? !step1Valid : !step2Valid}
                          style={{
                            padding: '10px 26px', borderRadius: 10, border: 'none',
                            fontSize: 14, fontWeight: 700, color: '#fff',
                            cursor: (createStep === 1 ? !step1Valid : !step2Valid) ? 'not-allowed' : 'pointer',
                            background: (createStep === 1 ? step1Valid : step2Valid)
                              ? 'linear-gradient(135deg,#781c2e,#a52a3d)' : '#e2e8f0',
                            boxShadow: (createStep === 1 ? step1Valid : step2Valid)
                              ? '0 4px 14px rgba(120,28,46,0.3)' : 'none',
                            display: 'flex', alignItems: 'center', gap: 6, transition: 'all 0.2s'
                          }}>
                          Continue <i className="bi bi-arrow-right"></i>
                        </button>
                      ) : (
                        <button onClick={handleSubmitCreate}
                          style={{
                            padding: '10px 26px', borderRadius: 10, border: 'none',
                            fontSize: 14, fontWeight: 700, color: '#fff', cursor: 'pointer',
                            background: 'linear-gradient(135deg,#781c2e,#a52a3d)',
                            boxShadow: '0 4px 14px rgba(120,28,46,0.35)',
                            display: 'flex', alignItems: 'center', gap: 7
                          }}>
                          <i className="bi bi-plus-circle-fill"></i> Create Roadmap
                        </button>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </Portal>
        )}

        {/* ════ MAIN PAGE ════ */}
        {viewMode === 'list' ? (
          <div className="card">
            {/* ── CARD HEADER ── */}
            <div className="card-header" style={{ display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:12 }}>
              <h2 className="section-title" style={{ margin:0 }}>
                <i className="bi bi-map"></i> Roadmap Suggestions
              </h2>

              <div style={{ display:'flex', alignItems:'center', gap:10, flexWrap:'wrap' }}>
                {/* Tabs */}
                <div className="tab-buttons">
                  <button className={`tab-btn ${activeTab === 'popular' ? 'active' : ''}`}
                    onClick={() => setActiveTab('popular')}>
                    <i className="bi bi-star-fill"></i> Popular
                  </button>
                  <button className={`tab-btn ${activeTab === 'trending' ? 'active' : ''}`}
                    onClick={() => setActiveTab('trending')}>
                    <i className="bi bi-graph-up-arrow"></i> Trending
                  </button>
                </div>

                {/* Create Roadmap Button */}
                <button onClick={openCreate} style={{
                  background: 'linear-gradient(135deg,#781c2e,#a52a3d)',
                  color: '#fff', border: 'none', borderRadius: 10,
                  padding: '10px 20px', fontSize: 13, fontWeight: 700, cursor: 'pointer',
                  display: 'flex', alignItems: 'center', gap: 8,
                  boxShadow: '0 3px 12px rgba(120,28,46,0.3)',
                  transition: 'all 0.2s', whiteSpace: 'nowrap'
                }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 18px rgba(120,28,46,0.4)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 3px 12px rgba(120,28,46,0.3)'; }}
                >
                  <i className="bi bi-plus-circle-fill" style={{ fontSize: 14 }}></i>
                  Create Roadmap
                </button>
              </div>
            </div>

            {/* Roadmap Grid */}
            <div className="roadmaps-grid">
              {allRoadmaps.map(r => <RoadmapCard key={r.id} roadmap={r} />)}
            </div>
          </div>
        ) : renderDetail()}

      </div>
    </MyMasterLayout>
  );
};

export default RoadmapSuggestions;